import { Component, Input, OnInit } from "@angular/core";
import { OrderAuditLogService } from "src/services/order-audit-log/order-audit-log.service";
import { components } from "src/shared/api-types";

@Component({
  selector: "rc-audit-log-list",
  templateUrl: "./audit-log-list.component.html",
  styleUrls: ["./audit-log-list.component.scss"],
  standalone: false,
})
export class AuditLogListComponent implements OnInit {
  @Input() orderId?: string;
  @Input() userId?: string;

  public auditLogs: components["schemas"]["ApiOrderAuditLog"][] = [];
  public totalCount = 0;
  public loading = false;
  private offset = 0;
  private readonly pageSize = 20;

  constructor(private readonly auditLogService: OrderAuditLogService) {}

  async ngOnInit() {
    await this.loadAuditLogs();
  }

  async loadAuditLogs() {
    const { orderId, userId } = this;
    this.loading = true;
    try {
      const response = orderId
        ? await this.auditLogService.getAuditLogsByOrderId(orderId, this.pageSize, this.offset)
        : userId
          ? await this.auditLogService.getUserAuditLogs(userId, this.pageSize, this.offset)
          : undefined;
      if (!response) {
        return;
      }

      this.auditLogs.push(...response.orderAuditLogs);
      this.totalCount = response.totalCount;
    } catch (error) {
      console.error("Failed to load audit logs", error);
    } finally {
      this.loading = false;
    }
  }

  async loadMore() {
    this.offset += this.pageSize;
    await this.loadAuditLogs();
  }

  get hasMore(): boolean {
    return this.auditLogs.length < this.totalCount;
  }
}
